var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "pa-0",
      class: { "pb-86px": _vm.isMobile },
      attrs: { id: "pripady-table-wrapper" }
    },
    [
      _vm.isMobile
        ? _c("h1", { staticClass: "ma-4" }, [_vm._v("Dokumenty")])
        : _vm._e(),
      _c(
        "div",
        { class: { "d-flex align-center": !_vm.isMobile } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-primary",
              class: { "mt-5 mb-3": !_vm.isMobile, "mx-4": _vm.isMobile },
              style: _vm.isMobile ? { width: "-webkit-fill-available" } : {},
              on: {
                click: function($event) {
                  _vm.dialog = true
                }
              }
            },
            [_vm._v(" Nahrať dokument ")]
          ),
          !_vm.isMobile
            ? _c(
                "v-btn",
                {
                  staticClass: "btn-secondary mt-5 mb-3 ml-5",
                  on: { click: _vm.goBack }
                },
                [_vm._v(" Späť ")]
              )
            : _vm._e()
        ],
        1
      ),
      _c("dokumenty-upload-dialog", {
        attrs: {
          "new-id": _vm.newId,
          "cislo-predmetu": _vm.cisloPredmetu,
          "poznamka-default": _vm.poznamka
        },
        on: {
          uploaded: function($event) {
            return _vm.loadData(null)
          }
        },
        model: {
          value: _vm.dialog,
          callback: function($$v) {
            _vm.dialog = $$v
          },
          expression: "dialog"
        }
      }),
      !_vm.isMobile
        ? [
            _c("v-data-table", {
              attrs: {
                "disable-pagination": false,
                headers: _vm.headers,
                items: _vm.items,
                "hide-default-footer": "",
                page: _vm.page,
                "items-per-page": 10,
                "single-select": false,
                "single-expand": false,
                "item-key": "id_dokumentu",
                loading: _vm.loading,
                "loading-text": "Načítavam dáta ..."
              },
              on: {
                "update:page": function($event) {
                  _vm.page = $event
                },
                "page-count": function($event) {
                  _vm.pageCount = $event
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item.stav",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("v-switch", {
                          on: {
                            change: function($event) {
                              return _vm.updateStatus(
                                item.id_dokumentu,
                                item.stav
                              )
                            }
                          },
                          model: {
                            value: item.stav,
                            callback: function($$v) {
                              _vm.$set(item, "stav", $$v)
                            },
                            expression: "item.stav"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "item.datum_aktualizacie",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.datum_aktualizacie
                          ? _c("span", [
                              _vm._v(
                                _vm._s(item.datum_aktualizacie.formatDate())
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.akcie",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "content-class": "pripady-table-menu",
                              "offset-x": "",
                              transition: "slide-x-transition",
                              left: "",
                              "open-on-hover": "",
                              "nudge-left": "5"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                dark: _vm.$vuetify.theme.dark,
                                                icon: ""
                                              }
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-dots-vertical")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c(
                              "v-list",
                              {
                                attrs: {
                                  id: "pripady-table-menu-list",
                                  elevation: "1"
                                }
                              },
                              _vm._l(_vm.menu, function(m, i) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: i,
                                    class: m.color,
                                    attrs: { link: "", dense: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.actionClick(
                                          m.nazov,
                                          item.new_id,
                                          item.cislo_verzie,
                                          item.pripona,
                                          item.nazov_dokumentu
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      { staticClass: "mr-4" },
                                      [
                                        _c("v-icon", {
                                          domProps: {
                                            textContent: _vm._s(m.icon)
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(m.nazov))
                                    ])
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              ),
              model: {
                value: _vm.selected,
                callback: function($$v) {
                  _vm.selected = $$v
                },
                expression: "selected"
              }
            })
          ]
        : [
            _vm.loading
              ? _c(
                  "v-row",
                  [
                    _c("v-col", { staticClass: "ml-4" }, [
                      _vm._v(" Načítavam dáta ... ")
                    ])
                  ],
                  1
                )
              : [
                  _vm.items.length > 0
                    ? _vm._l(_vm.items, function(item, index) {
                        return _c(
                          "v-row",
                          {
                            key: index,
                            staticClass:
                              "mobile-dokumenty-card d-flex flex-wrap",
                            attrs: { "no-gutters": "" }
                          },
                          [
                            _vm._l(
                              _vm.headers.filter(function(h) {
                                return (
                                  h.value !== "akcie" &&
                                  !(
                                    h.value == "poznamka" &&
                                    item.poznamka == null
                                  )
                                )
                              }),
                              function(header) {
                                return _c(
                                  "v-col",
                                  {
                                    key: header.value,
                                    staticClass: "pt-4",
                                    attrs: { cols: "12" }
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "f12 gs100 break-word"
                                            },
                                            [_vm._v(_vm._s(header.text))]
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "f16 bold break-word"
                                            },
                                            [_vm._v(_vm._s(item[header.value]))]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [_c("v-divider", { staticClass: "my-16px" })],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass:
                                  "btn-secondary btn-icon mx-4 mb-6 mt-2",
                                staticStyle: { border: "0 !important" },
                                on: {
                                  click: function($event) {
                                    return _vm.actionClick(
                                      "Zobraziť dokument",
                                      item.new_id,
                                      item.cislo_verzie,
                                      item.pripona,
                                      item.nazov_dokumentu
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "f24",
                                    attrs: { color: "#0097fd" }
                                  },
                                  [_vm._v("mdi-file-document-outline")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-secondary btn-icon mb-6 mt-2",
                                staticStyle: { border: "0 !important" },
                                on: {
                                  click: function($event) {
                                    return _vm.actionClick(
                                      "Zmazať",
                                      item.new_id,
                                      item.cislo_verzie,
                                      item.pripona,
                                      item.nazov_dokumentu
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "f20",
                                    attrs: { color: "#0097fd" }
                                  },
                                  [_vm._v("$trash")]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      })
                    : [
                        _c(
                          "v-row",
                          [
                            _c("v-col", { staticClass: "ml-4" }, [
                              _vm._v(" Nie sú dostupné žiadne dáta. ")
                            ])
                          ],
                          1
                        )
                      ]
                ]
          ],
      _vm.isMobile
        ? [
            _c(
              "div",
              { staticClass: "mobile-bottom-div" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "btn-primary ma-4",
                    staticStyle: { width: "-webkit-fill-available" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v(" Späť ")]
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }